import React from "react";
import { Box } from "@mui/material";
import CallIcon from "@mui/icons-material/Call";
import "./Footer.css";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import MailOutlineIcon from "@mui/icons-material/MailOutline";

const Footer = ({ bd }) => {
  return (
    <div style={{ borderTop: "1px solid white" }}>
      <Box className="box">
        <a
          href="tel:+8801777313350"
          className={bd === "dark" ? "faColor" : "faColorb"}
          target="_blank"
          rel="noopener noreferrer"
        >
          <CallIcon className="fsocialIcon"></CallIcon>
          <span className="text">+8801777313350</span>
        </a>
        <a
          href="https://wa.me/+8801777313350?text=Hi"
          className={bd === "dark" ? "faColor" : "faColorb"}
          target="_blank"
          rel="noopener noreferrer"
        >
          <WhatsAppIcon className="fsocialIcon"></WhatsAppIcon>
          <span className="text">+8801777313350</span>
        </a>
        <a
          href="mailto:ratonkumar3267@gmail.com"
          className={bd === "dark" ? "faColor" : "faColorb"}
          target="_blank"
          rel="noopener noreferrer"
        >
          <MailOutlineIcon className="fsocialIcon"></MailOutlineIcon>
          <span className="text">ratonkumar3267@gmail.com</span>
        </a>
      </Box>
    </div>
  );
};

export default Footer;
